import { CountryEnv, LANGUAGE } from "@type/index";

const _countryEnv: CountryEnv = {
  clientId: process.env.REACT_APP_CLIENT_ID_US_GU || "gu.us.new-styling-book",
  sbRootId: process.env.REACT_APP_FILTERS_SB_ROOT_ID_US_GU || 0,
  shRootId: process.env.REACT_APP_FILTERS_SH_ROOT_ID_US_GU || 0,
  firebaseApiKey: process.env.REACT_APP_FIREBASE_API_KEY_US_GU || "",
  firebaseProjectId: process.env.REACT_APP_FIREBASE_PROJECT_ID_US_GU || "",
  firebaseAppId: process.env.REACT_APP_FIREBASE_APP_ID_US_GU || "",
  firebaseMeasurementId:
    process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_US_GU || "",
  storeDomain: process.env.REACT_APP_STORE_DOMAIN_GU || "",
  showAboutApp: true,
  showDualPrice: false,
  languages: [LANGUAGE.EN],
  countryRegion: "America/New_York",
  timeZone: {
    [LANGUAGE.EN]: {
      defaultTimezone: "EST",
      offset: {
        EST: -5,
        EDT: -4
      }
    }
  },
  dateFormat: {
    [LANGUAGE.EN]: "<MM>/<DD>/<yyyy>"
  },
  requireDecimal: true
};

export default _countryEnv;
